var a = {};
export {
  a as __exports
};
//# sourceMappingURL=index.es340.js.map
